import { action, payload } from 'ts-action'

import { IFavorite } from 'models/Favorite'
import { IError, IPayload } from 'models/Global'

export const FavoredBusinessesFetching = action(
  'FavoredBusinessesFetching',
  payload<boolean>(),
)

export const GetFavoredBusinesses = action(
  'GetFavoredBusinesses',
  payload<IPayload<IFavorite[]>>(),
)

export const GetFavoredBusinessesErrors = action(
  'GetFavoredBusinessesErrors',
  payload<IError>(),
)

export const ClearFavoredBusinessesReducer = action(
  'ClearFavoredBusinessesReducer',
)

export const FavoredBusinessesUnfavoriteBusiness = action(
  'FavoredBusinessesUnfavoriteBusiness',
  payload<number>(),
)
